import styled from 'styled-components';
import { mixins, media } from '@pik/pik-ui';

const S = {};

S.VideoWrapper = styled.div`
 
`;

S.VideoPlay = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 64px;
  height: 64px;
  background: #fff;
  border-radius: 100%;
  z-index: 2;
  ${mixins.flex()};
  opacity: 0;
  ${mixins.animation('opacity')};

  svg {
    margin-right: -2px;
  }
`;

S.VideoTitle = styled.div`
  position: absolute;
  left: 24px;
  bottom: 24px;
  font-weight: 500;
  font-size: 32px;
  line-height: 38px;
  color: #fff;
  letter-spacing: 0;
  z-index: 1;
  white-space: pre-wrap;
  
  @media ${media.max1024} {
    display: none;
  }
`;

S.VideoHover = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,.1);
  ${mixins.animation('background')};
`;

S.Video = styled.div`
  box-sizing: border-box;
  position: relative;
  height: 272px;
  max-width: 544px;
  flex: 0 0 544px;
  border-radius: 4px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  
  &.video-page {
    width: 352px;
    height: 176px;
    margin: 0;
  }
 
  &:hover {
    cursor: pointer;
    
    ${S.VideoPlay} {
      opacity: 1;
    }
    
    ${S.VideoHover} {
      background: rgba(0,0,0,.3);
    }
  } 
  
  @media ${media.max1120} {
    max-height: 400px;
    margin-right: 0;
    max-width: 100%;
    flex: 0 0 456px;
    
    &.video-page {
        width: 452px;
        height: 226px;
        margin: 0;
    }
  }
  
  @media ${media.max1024} {
  
  padding-bottom: 56.25%;
    &.video-page {
        width: 350px;
        height: 175px;
        max-height: auto;
    }
  }
  
  @media ${media.max768} {
    box-sizing: border-box;
    width: 100%;
    min-width: 100%;
    padding-bottom: 56.25%;
    &.video-page {
        width: 100%;
        
    }
  }
  
  @media ${media.max360} {
    height: 188px;
    flex-basis: 316px;
    min-width: 100%;
  }
`;

S.VideoImage = styled.img`
  object-fit: cover;
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 4px;
  top: 0;
  left: 0;
`;

S.BottomTitle = styled.div`
  display: none;
  &.video-page {
    display: block
  }
  @media ${media.max1024} {
    display: block
  }
  margin-top: 8px;
`;

S.Date = styled.div`
  display: none;
  &.video-page {
    display: block
  }
  @media ${media.max1024} {
    display: block
  }
  color: #969BA5;
`;

export default S;
